import React from 'react'

import { Cell, Line, Terminal } from '../interface'

import { Cell as CellComponent } from './Cell'

export interface RowProps {
    cells: Cell[]
    terminalCellDict: Array<Array<Terminal | undefined>>
    lineSourceCellDict: Array<Array<Array<Line>>>
    lineDestinationCellDict: Array<Array<Array<Line>>>
}

export const Row = React.memo((props: RowProps): JSX.Element => {
    const { cells, terminalCellDict, lineSourceCellDict, lineDestinationCellDict } = props

    return <> {
        cells.map((cell: Cell, index: number) => {
            const terminal = terminalCellDict[cell.row][cell.column]
            const lineSources = lineSourceCellDict[cell.row][cell.column]
            const lineDestinations = lineDestinationCellDict[cell.row][cell.column]

            return <CellComponent key={index}
                terminal={terminal} lineSources={lineSources}
                lineDestinations={lineDestinations} />
        })
    } </>
}, (prevProps: RowProps, nextProps: RowProps) => {
    const row = nextProps.cells[0].row

    for (let i = 0; i < nextProps.cells.length; i++) {
        if (prevProps.cells[i] !== nextProps.cells[i]) return false

        if (prevProps.terminalCellDict[row][i] !==
            nextProps.terminalCellDict[row][i]) return false

        if (prevProps.lineSourceCellDict[row][i][0] !==
            nextProps.lineSourceCellDict[row][i][0]) return false
        if (prevProps.lineSourceCellDict[row][i][1] !==
            nextProps.lineSourceCellDict[row][i][1]) return false
        if (prevProps.lineDestinationCellDict[row][i][0] !==
            nextProps.lineDestinationCellDict[row][i][0]) return false
        if (prevProps.lineDestinationCellDict[row][i][1] !==
            nextProps.lineDestinationCellDict[row][i][1]) return false

    }
    return true
})
